import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class MatIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      "filter-sliders",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/settings-adjust.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "close-dark",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/close-dark.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/close.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "home",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/home.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "user",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/user-alt.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "service",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/task--tools.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "purchase",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/shopping--cart.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "search",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/search.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "chevronDown",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/chevron--down.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "chevronRight",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/chevron--right.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "warning",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/warning.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "warningFilled",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/warning--filled.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "edit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/edit.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "checkbox-checked-green",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "../assets/img/checkbox-checked-round-green.svg",
      ),
    );
    this.matIconRegistry.addSvgIcon(
      "checkmark",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/checkmark.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "submit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/send.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "undo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/undo.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "download",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/download2.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "information",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/information.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "version",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/version.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "data-enrichment--add",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/data-enrichment--add.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "status--change",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/status--change.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "tools",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/tools.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "password",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/password.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "fingerprint-recognition",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/fingerprint-recognition.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "trash-can",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/trash-can.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "outage",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/outage.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "result--old",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/result--old.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "recently-viewed",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/recently-viewed.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "calendar--tools",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/calendar--tools.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "tool-kit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/tool-kit.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "reply--all",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/reply--all.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "reply",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/reply.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "data-backup",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/data-backup.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "data-table",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/data-table.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "file-excel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/file-excel-solid.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "license--maintenance",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/license--maintenance.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "chevronLeft",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/chevron--left.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "addCircle",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/add--alt.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "add",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/add.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "phone",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/phone--voice--filled.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "email",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/email.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "catalog",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/catalog.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "cloud-download",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/cloud--download.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "close-transparent",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/close-transparent.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "error",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/error.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "parcel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/parcel.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "add-parcel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/addParcel.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "copy",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/copy.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "scale",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/scale.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "weight",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/weight-hanging-solid.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "delivery--parcel",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/delivery--parcel.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "calendar",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/calendar.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "barcode",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/img/barcode.svg"),
    );
  }
}
